import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 160 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.2889 14.5555L43.8889 14.4889L43.0222 17.2222L30.4889 47.2222H24.0222L11.4889 17.2889L10.4889 14.1555L10.0889 14.2222V47.2222H0.488892V0.555542H13.2889L26.3556 32.4889L27.0222 35.4889H27.4222L28.0889 32.4889L41.2222 0.555542H53.8889V47.2222H44.2889V14.5555Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2889 0.555542H77.6889C89.4222 0.555542 95.8889 6.28888 95.8889 13.2222C95.8889 17.4889 93.4222 21.2222 89.4222 22.8889V23.2889C95.1556 24.7555 98.5556 29.3555 98.5556 34.5555C98.5556 41.5555 92.0889 47.2222 80.3555 47.2222H63.2889V0.555542ZM72.8889 8.42221V19.8889H78.8889C83.8889 19.8889 86.2889 17.4889 86.2889 13.8889C86.2889 11.0222 83.6889 8.42221 78.2222 8.42221H72.8889ZM72.8889 27.2222V39.3555H80.8889C86.0889 39.3555 88.9555 37.2222 88.9555 33.7555C88.9555 29.8889 86.4222 27.2222 81.5556 27.2222H72.8889Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.756 0.555542H119.956C135.222 0.555542 144.889 10.6222 144.889 23.8889C144.889 37.1555 135.222 47.2222 119.956 47.2222H105.756V0.555542ZM115.356 8.42221V39.3555H119.956C129.622 39.3555 135.289 32.8889 135.289 23.8889C135.289 15.2889 129.622 8.42221 119.956 8.42221H115.356Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.556 47.3333H150C150 47.3333 150 46.9333 150 46.4444V37.7778H159.778L159.578 46.4444C159.556 46.9333 159.556 47.3333 159.556 47.3333Z",
			fill: "white"
		})
	]
});
export default SvgLogoIcon;
